import React from 'react';
import {View, Text, ScrollView, StyleSheet} from 'react-native';
import OrderItem from '../../commons/orderItem';
import OrderItemImage from '../../commons/orderItemImage';
import {fontFamily} from '../../helpers/fontFamily';

const ItemColumn = ({title, items, listType = 'unscanned', onItemPress = () => {}}) => (
  <View style={styles.container}>
    <Text style={styles.header}>{title}</Text>
    <ScrollView style={styles.scroll} showsVerticalScrollIndicator={false}>
      {items.map((item, index) => {
        const safeItem = {
          ...item,
          barcodes: item.barcodes || [],
          images: item.images || []
        };
        return (
          <View
            key={`${item.order_item_id || item.product_id}-${index}`}
            style={styles.itemWrapper}>
            <View style={styles.itemContainer}>
              <OrderItem
                item={safeItem}
                redirectToItemDetail={onItemPress}
                testID="putWallColumnItem"
              />
              <OrderItemImage
                item={safeItem}
                listType={listType}
                shuffleTheItem={() => onItemPress(safeItem)}
                testID="putWallColumnImage"
              />
            </View>
          </View>
        );
      })}
    </ScrollView>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  header: {
    color: '#fff',
    fontSize: 15,
    fontFamily: fontFamily.font600,
    textAlign: 'center',
    backgroundColor: '#000',
    paddingVertical: 10
  },
  scroll: {
    flex: 1
  },
  itemWrapper: {
    marginBottom: 8
  },
  itemContainer: {
    flexDirection: 'row',
    borderRadius: 30
  }
});

export default ItemColumn;
